import { Link } from 'react-router';
import { Table, Button, Breadcrumb, BPanel } from '@sketchpixy/rubix';
import React from 'react';

import { Meteor } from 'meteor/meteor';

import { Reactive } from '../common/Reactive.mixin.js';

import { FlightsType } from '../../collections/flights-type/flights-type';
import FlightListComponent from './component-flights-type-list';

@Reactive({
	subscriptions: ["flights-type"],
	flights: FlightsType.find({partnerId: {$exists: false}}),
})
export default class FlightsListPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

	}

	renderFlights() {
		return this.props.flights.map((flight) => (
			<FlightListComponent key={flight._id} flight={flight} />
		));
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Vols
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des vols
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/flights-add"><Button bsStyle="success">Ajouter</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des vols">
					<Table responsive>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Générique ?</th>
								<th>Date de création</th>
								<th>Dernière modification</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{this.renderFlights()}
						</tbody>
					</Table>
				</BPanel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights-type/FlightsTypeList.page.js
 **/